import { render, staticRenderFns } from "./LandingSafeguards.html?vue&type=template&id=e34de598&scoped=true&"
import script from "./LandingSafeguards.ts?vue&type=script&lang=ts&"
export * from "./LandingSafeguards.ts?vue&type=script&lang=ts&"
import style0 from "./LandingSafeguards.scss?vue&type=style&index=0&id=e34de598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34de598",
  null
  
)

export default component.exports